import { ContentLibraryGate } from '@/components/contentLibrary/ContentLibraryGate';
import { ContentLibraryItem } from '@/components/contentLibrary/contentLibraryItem';

export default function ContentLibraryItemRoute() {
  return (
    <ContentLibraryGate source="item">
      <ContentLibraryItem />
    </ContentLibraryGate>
  );
}
